import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgxPaginationModule } from "ngx-pagination";
import { SelectModule } from "ng2-select";
import { BsDatepickerModule, BsDropdownModule, CollapseModule } from "ngx-bootstrap";
import { PlannedServiceListComponent } from "app/client/plannedService/list/plannedService-list.component";
import { PipeModule } from "app/pipes/pipe.module";

@NgModule({
  declarations: [
    PlannedServiceListComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    NgxPaginationModule,
    CollapseModule.forRoot(),
    BsDatepickerModule,
    BsDropdownModule,
    SelectModule,
    PipeModule
  ]
})
export class PlannedServiceListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/plannedService/list/plannedService-list.module.ts